<template>
  <div class="warp">
    <img class="top_bg top_bg2" src="@/assets/img/digitalBooks/bg.png" alt="" />
    <div class="layout_con page_w">
      <!-- content -->
      <my-header @num="num"></my-header>
      <!-- 面包屑 -->
      <div class="crumbs_warp">
        <div class="crumbs_box">
          <div class="flex">
            <i class="crumbs_icon">
              <img src="@/assets/img/common/crumbs_icon.png" alt="" />
            </i>
            <div class="crumbs crumbs_black">
              <router-link class="item" to="/">首页 &gt;</router-link>
              <router-link class="item" to="/digitalBooks">关于我们 </router-link>
            </div>
          </div>
        </div>
        <router-link class="back flex" to="/">返回</router-link>
      </div>
      <!--      简介-->
      <div class="content_warp">
        <div class="title">
          <img src="@/assets/img/about_title.png" alt="" />
        </div>
        <div class="con" v-html="con"></div>
        <div class="tit">平台古籍清单</div>
        <div class="list">

          <div class="item ">
            <div class="name title">
              <span>藏品名稱</span>
            </div>
            <div class="author title">
              <span>著者姓名</span>
            </div>
            <div class="version title">
              <span>版本信息</span>
            </div>
            <div class="type title">
              <span>古籍分類</span>
            </div>
          </div>
          <div class="item" v-for="(item,index) in bookJson" :key="index">
            <div class="name">
              <span>{{item.name}}</span>
            </div>
            <div class="author">
              <span>{{item.author}}</span>
            </div>
            <div class="version">
              <span>{{item.version}}</span>
            </div>
            <div class="type">
              <span>{{item.type}}</span>
            </div>
          </div>
        </div>
      </div>



      <!-- content end -->
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import bookJson from '@/api/book02.json'
import myHeader from '@/components/myHeader/index'
import myFooter from '@/components/myFooter/index'
import { getAbout } from '@/api/index.js'
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      num: 3,
      con: '',
      bookJson:bookJson
    }
  },
  mounted() {
    this.getAbout()
    console.log(bookJson)

  },
  methods: {
    async getAbout() {
      const res = await getAbout()
      console.log(res, 55555555)
      this.con = res.content
    }
  }
}
</script>

<style lang="less" scoped>
.retrieval_warp {
  width: 100%;
  height: 340px;
  background-size: 100% 100%;
  overflow: hidden;
}
.content_warp {
  width: 1200px;
  margin: 0 auto;
  background-color: #efe9e1;
  box-shadow: 0px 0px 6px 0px rgba(34, 24, 20, 0.2);
  padding: 80px ;
  img {
    width: 294px;
    margin: 0 auto;
  }
  .tit{
    color: #555555;
    width: 100%;
    height: 66px;
    line-height: 66px;
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    border: 1px solid black;
    border-bottom:0px solid black;
  }
  .list{
    color: #555555;
    border: 1px solid black;
    border-bottom:0px solid black;

    .title{
      font-weight: 600;
      font-size: 18px;
    }
   .item{
     font-size: 16px;
     font-weight: 400;
     color: #555555;
     display: flex;
     line-height: 26px;
     border-bottom: 1px solid black;
     text-align: center;
     .name{
       padding: 20px 0 ;
       width:300px;
       border-right: 1px solid black;
     }
     .author{
       padding: 20px 0  ;
       width: 180px;
       border-right: 1px solid black;
     }
     .version{
       padding: 20px 0  ;
       width:600px;
       border-right: 1px solid black;
     }
     .type{
       padding: 20px 0  ;
       width: 360px;
     }
   }
  }
  .con {
    padding-top: 50px;
    font-size: 16px;
    font-weight: 400;
    color: #555555;
    line-height: 60px;
    letter-spacing: 1.8px;
    padding-bottom: 30px;
  }
}
@media screen and (max-width: 1280px) {
  .picture_list {
    li {
      width: 33% !important;
    }
  }
}

</style>
